import React, { useState } from "react";
import { ChevronDown } from "lucide-react";

const FaqAccordionItem = ({ q, a, defaultOpen = false }) => {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div className="border border-[var(--land-line)] rounded-[16px] bg-[var(--land-panel)] overflow-hidden transition-colors duration-200 hover:border-[var(--land-primary)]">
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className="w-full flex items-center justify-between gap-4 p-5 text-left"
        aria-expanded={open}
      >
        <span className="font-semibold text-[15px] text-[var(--land-ink)]">{q}</span>
        <ChevronDown
          size={18}
          className={[
            "transition-transform duration-300 flex-none",
            open ? "rotate-180 text-[var(--land-primary)]" : "text-[var(--land-muted)]",
          ].join(" ")}
        />
      </button>
      <div className="grid transition-[grid-template-rows] duration-300 ease-out" style={{ gridTemplateRows: open ? "1fr" : "0fr" }}>
        <div className="overflow-hidden">
          <p className="text-[var(--land-muted)] text-sm px-5 pb-5 leading-relaxed">{a}</p>
        </div>
      </div>
    </div>
  );
};

export default FaqAccordionItem;
